import Api from "lib/api";
export const API_PATH = "/api/v1/attendance-employee";

export const getEmployee = async (employee_id) => {
  return Api.get(`${API_PATH}/employee/employee_id`, {
    employee_id: employee_id,
  });
};


export const getAttendance = async (from, to, employee_id) => {
  return Api.get(`${API_PATH}/attendance/date`, {
    from: from,
    to: to,
    employee_id: employee_id,
  });
};
export const saveAttendance = async (attendanceList) => {
  return Api.post(`${API_PATH}/save-attendance`, attendanceList);
};
export const deleteAttendance = async (attendanceList) => {
  return Api.post(`${API_PATH}/delete-attendance`, attendanceList);
};
